export default __webpack_public_path__ + "static/media/CIV.ee738a90.svg";